module.exports = __webpack_public_path__ + "static/media/zoology_banner.3210a781.png";